<template>
  <div>
    <div class="home_img">
      <img src="@/assets/home_fm.png" alt="" />
    </div>
    <div class="home_info">
      <div class="top_info">
        <div class="top_info_border">
          <div class="info_title" style="color: rgba(0, 0, 0, 0.8)">
            经营项目 <span>BUSINESS SCOPE</span>
            <div class="more_info_title">view more</div>
          </div>
          <div class="info_hr"></div>
          <div class="info_muen_list">
            <div class="menu_list_item" v-for="(item, i) in topInfoMenu" :key="i">
              <div class="item_img">
                <img :src="item.img" alt="" />
              </div>
            </div>
          </div>
          <div class="info_company">
            <div class="company_left_info">
              <div class="company_img">
                <img src="@/assets/company_bg.png" alt="" />
              </div>
              <div class="company_desc" :class="{ collapsed: !showFullDesc }">
                <div class="cmpany_desc_title">公司简介</div>
                <div class="desc_text">{{ infoJson.companyInfo.desc }}</div>
                <div class="desc_toggle" @click="toggleDesc">
                  <span v-if="!showFullDesc">... 查看详情</span>
                </div>
              </div>
            </div>
            <div class="company_right_info">
              <div class="right_title">
                <div class="right_title_name">公司动态</div>
                <div class="right_title_more">more</div>
              </div>
              <div class="right_dynamic">
                <div class="dynamic_list" v-for="(item, i) in infoJson.companyDynamic" :key="i">
                  <div class="dynamic_title">{{ item.title }}</div>
                  <div class="dynamic_date">{{ item.date }}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="info_title" style="margin-top: 35px; color: rgba(0, 0, 0, 0.8)">
            荣誉资质 <span>HONOR & QUALIFICATION</span>
            <div class="more_info_title">view more</div>
          </div>
          <div class="info_hr"></div>
          <div class="company_qualification">
            <el-carousel :interval="infoJson.companyInfo.bannerSpeed" type="card" height="330px">
              <el-carousel-item v-for="(item, i) in infoJson.companyQualification" :key="i">
                <div class="qualification_img">
                  <img :src="requireImg(item.img)" :alt="item.title" />
                </div>
                <div class="qualification_title">
                  {{ item.title }}
                </div>
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
      </div>
      <div class="company_cases">
        <div class="cases_info">
          <div class="info_title" style="margin-top: 35px">
            工程业绩 <span>PROJECT PERFORMANCE</span>
            <div class="more_info_title">view more</div>
          </div>
          <div class="info_hr"></div>
          <div class="cases_menu">
            <div class="cases_item" v-for="(item, i) in infoJson.companyCases" :key="i" :style="{
              color: projectPerfrmanceI == item.name ? '#619533' : '',
            }" @click="casesHandle(item)">
              {{ item.name }}
            </div>
          </div>
          <div class="company_qualification">
            <el-carousel :interval="infoJson.companyInfo.bannerSpeed" type="card" height="330px">
              <el-carousel-item v-for="(item, i) in casesImgList" :key="i">
                <div class="qualification_img">
                  <img :src="requireImgCase(item.url)" :alt="item.title" />
                </div>
                <div class="qualification_title">
                  {{ item.name }}
                </div>
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
      </div>
      <div class="staff_info">
        <div class="info_title" style="margin-top: 35px; color: rgba(0, 0, 0, 0.8)">
          员工风采 <span>STAFF ELEGANT DEMEANOR</span>
          <div class="more_info_title">view more</div>
        </div>
        <div class="info_hr"></div>
        <div class="company_qualification">
          <el-carousel :interval="infoJson.companyInfo.bannerSpeed" type="card" height="330px">
            <el-carousel-item v-for="(item, i) in infoJson.companyQualification" :key="i">
              <div class="qualification_img">
                <img :src="requireImg(item.img)" :alt="item.title" />
              </div>
              <div class="qualification_title">
                {{ item.name }}
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </div>
    <div class="bottom_bg">
      <img src="@/assets/home_bottom_bg.jpg" alt="" />
    </div>
    <div class="bottom_info">
      <div class="bottom_info_left">
        <div class="left_info_title">联系我们</div>
        <div class="left_info_address">
          <i class="el-icon-location-outline"></i> 地址：{{
            infoJson.companyInfo.address
          }}
        </div>
        <div class="left_info_address">
          <i class="el-icon-phone-outline"></i>
          电话：{{ infoJson.companyInfo.phone }}
        </div>
        <div class="left_info_address">
          <i class="el-icon-takeaway-box"></i>邮箱：{{
            infoJson.companyInfo.email
          }}
        </div>
      </div>
      <div class="bottom_info_right">
        <div class="right_info_title">“守合同重信用”企业</div>
        <div class="right_info_company">亘立建筑咨询热线：</div>
        <div class="right_info_phone">{{ infoJson.companyInfo.phone }}</div>
      </div>
    </div>
    <div class="home_hr"></div>
    <div class="yq_link">
      <div class="link_title">友情链接:</div>
      <div class="link_item" v-for="(item, i) in infoJson.friendshipLinks" :key="i" :style="{
        borderRight:
          i !== infoJson.friendshipLinks.length - 1
            ? '1px solid rgba(0, 0, 0, 0.2)'
            : '',
      }">
        <a :href="item.url" target="_blank">{{ item.name }}</a>
      </div>
    </div>
  </div>
</template>

<script>
import infoJson from "@/utils/info.json";
export default {
  data() {
    return {
      infoJson,
      showFullDesc: false,
      casesImgList: [],
      projectPerfrmanceI: "水利水电",
      topInfoMenu: [
        {
          name: "水利水电",
          img: require("@/assets/work_type1.jpg"),
        },
        {
          name: "房屋建筑",
          img: require("@/assets/work_type2.jpg"),
        },
        {
          name: "市政工程",
          img: require("@/assets/work_type3.jpg"),
        },
        {
          name: "公路工程",
          img: require("@/assets/work_type4.jpg"),
        },
      ],
    };
  },
  mounted() {
    this.casesImgList = infoJson.companyCases[0].imgList;
  },
  methods: {
    casesHandle(item) {
      console.log('item', item)
      this.projectPerfrmanceI = item.name;
      this.casesImgList = item.imgList;
    },
    requireImgCase(img) {
      return require(`@/assets/${img}`);
    },
    requireImg(img) {
      return require(`@/assets/qualification/${img}.png`);
    },
    toggleDesc() { },
  },
};
</script>

<style lang="scss" scoped>
.yq_link {
  padding: 30px 15%;
  display: flex;

  .link_item {
    width: 80px;
    line-height: 20px;
    margin-left: 20px;
    text-align: center;
    height: 20px;
  }

  .link_title {
    font-size: 20px;
    font-weight: bold;
    color: rgba(0, 0, 0, 0.7);
    line-height: 20px;
  }
}

.home_hr {
  height: 1px;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.2);
  margin-top: 10px;
}

.bottom_info {
  width: 100%;
  padding: 60px 15%;
  display: flex;

  .bottom_info_right {
    color: #434343;

    .right_info_phone {
      color: #ff7e00;
      font-size: 30px;
      font-weight: bold;
      margin: 10px 0 0 10px;
    }

    .right_info_company {
      margin: 20px 0 0 10px;
    }

    .right_info_title {
      font-size: 24px;
      font-weight: bold;
    }
  }

  .bottom_info_left {
    width: 30%;
    color: #434343;

    .left_info_address {
      margin: 20px 0;
      display: flex;

      i {
        margin-right: 5px;
        font-size: 24px;
      }
    }

    .left_info_title {
      font-size: 24px;
      font-weight: bold;
    }
  }
}

.bottom_bg {
  width: 100vw;
  height: 50vh;

  img {
    width: 100%;
    height: 100%;
  }
}

.home_info {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;

  .info_title {
    font-size: 24px;
    font-weight: bold;
    color: #fff;
    padding-top: 15px;
    position: relative;
    cursor: pointer;

    .more_info_title {
      position: absolute;
      right: 20px;
      top: 50%;
      color: rgba(0, 0, 0, 0.5);
      font-size: 14px;
      transform: translateY(-30%);

      &:hover {
        color: #619533;
      }
    }

    span {
      font-size: 14px;
      color: #619533;
      margin-left: 10px;
    }
  }

  .info_hr {
    height: 1px;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.2);
    margin-top: 10px;
  }

  .staff_info {
    width: 70%;
    padding: 0 15%;

    .company_qualification {
      margin-top: 20px;

      .qualification_title {
        position: absolute;
        bottom: 20px;
        left: 50%;
        transform: translateX(-50%);
        color: rgba(0, 0, 0, 0.8);
      }

      .qualification_img {
        width: 380px;
        height: 260px;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);

        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }

  .company_cases {
    width: 100%;
    background-image: url(@/assets/cases_bg.jpg);
    background-size: 100% 100%;

    ::v-deep .el-carousel__mask {
      background: rgba(0, 0, 0, 0);
    }

    .cases_info {
      width: 70%;
      padding: 0 15%;
    }

    .info_hr {
      height: 1px;
      width: 100%;
      background-color: rgba(255, 255, 255);
      margin-top: 10px;
    }

    .company_qualification {
      margin-top: 20px;

      .qualification_title {
        position: absolute;
        bottom: 20px;
        left: 50%;
        transform: translateX(-50%);
        color: #fff;
      }

      .qualification_img {
        width: 380px;
        height: 260px;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);

        img {
          width: 100%;
          height: 100%;
        }
      }
    }

    .cases_menu {
      margin-top: 15px;
      display: flex;
      color: #fff;

      .cases_item {
        width: calc(100% / 10);
        cursor: pointer;

        &:hover {
          color: #619533;
        }
      }
    }
  }

  .top_info {
    margin-top: -340px;
    width: 70%;
    min-height: 400px;
    background: rgba(255, 255, 255, 0.3);
    padding: 1% 1%;

    .top_info_border {
      width: 100%;
      min-height: 300px;
      background: #fff;

      .company_qualification {
        margin-top: 20px;

        .qualification_title {
          position: absolute;
          bottom: 20px;
          left: 50%;
          transform: translateX(-50%);
        }

        .qualification_img {
          width: 380px;
          height: 260px;
          position: absolute;
          left: 50%;
          transform: translateX(-50%);

          img {
            width: 100%;
            height: 100%;
          }
        }
      }

      .info_company {
        display: flex;
        margin-top: 35px;

        .company_left_info {
          display: flex;
          width: 60%;

          .company_img {
            width: 55%;

            img {
              width: 100%;
              height: 230px;
              border-radius: 7px;
            }
          }

          .company_desc {
            width: 45%;
            padding: 0 20px;
            font-size: 16px;
            color: #494949;
            line-height: 24px;
            text-align: left;

            .cmpany_desc_title {
              font-size: 20px;
              font-weight: bold;
              color: #000;
              margin-bottom: 10px;
            }

            .desc_text {
              text-indent: 2em;
              transition: all 0.3s ease;
            }

            .desc_toggle {
              color: #619533;
              cursor: pointer;
              font-size: 14px;
              font-weight: 600;
            }

            &.collapsed {
              .desc_text {
                max-height: 170px;
                overflow: hidden;
                display: -webkit-box;
                -webkit-box-orient: vertical;
              }
            }
          }
        }

        .company_right_info {
          width: 40%;

          .right_dynamic {
            .dynamic_list {
              display: flex;
              font-size: 16px;
              color: #494949;
              margin-top: 4px;
              cursor: pointer;

              .dynamic_title {
                text-align: left;
                width: 70%;
                overflow: hidden;
                /* 隐藏超出内容 */
                text-overflow: ellipsis;
                /* 显示省略号 */
                white-space: nowrap;
                /* 强制不换行 */
              }

              .dynamic_date {
                margin-left: auto;
                color: rgba(0, 0, 0, 0.5);
              }

              &:hover {
                color: #619533;
              }
            }
          }

          .right_title {
            display: flex;

            .right_title_name {
              font-size: 20px;
              font-weight: bold;
              color: #000;
            }

            .right_title_more {
              color: #619533;
              cursor: pointer;
              font-size: 14px;
              font-weight: 600;
              margin-left: auto;
              margin-right: 10px;
            }
          }
        }
      }

      .info_muen_list {
        display: flex;
        margin-top: 10px;

        .menu_list_item {
          width: 25%;
          cursor: pointer;

          .item_img {
            width: 100%;
            overflow: hidden;

            img {
              width: 100%;
              height: 100%;
              transition: transform 0.3s ease;
            }

            &:hover {
              img {
                transform: scale(0.9);
              }
            }
          }
        }
      }
    }
  }
}

.home_img {
  overflow: hidden;

  img {
    width: 100%;
    height: 80%;
  }
}
</style>
